
    import './styles.scoped.css';
    export default {
  "input-adorned-container": "awsui_input-adorned-container_2rhyz_32ma4_9",
  "input": "awsui_input_2rhyz_32ma4_9",
  "input-adorned-container-readonly": "awsui_input-adorned-container-readonly_2rhyz_32ma4_22",
  "input-readonly": "awsui_input-readonly_2rhyz_32ma4_22",
  "root": "awsui_root_2rhyz_32ma4_35",
  "input-invalid": "awsui_input-invalid_2rhyz_32ma4_138",
  "input-has-icon-start": "awsui_input-has-icon-start_2rhyz_32ma4_147",
  "input-warning": "awsui_input-warning_2rhyz_32ma4_150",
  "input-type-search": "awsui_input-type-search_2rhyz_32ma4_162",
  "input-has-icon-end": "awsui_input-has-icon-end_2rhyz_32ma4_175",
  "input-has-no-border-radius": "awsui_input-has-no-border-radius_2rhyz_32ma4_178",
  "grouped": "awsui_grouped_2rhyz_32ma4_185",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_2rhyz_32ma4_191",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_2rhyz_32ma4_195",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_2rhyz_32ma4_201",
  "grouped-vertical-first": "awsui_grouped-vertical-first_2rhyz_32ma4_205",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_2rhyz_32ma4_209",
  "grouped-vertical-last": "awsui_grouped-vertical-last_2rhyz_32ma4_215",
  "input-container": "awsui_input-container_2rhyz_32ma4_220",
  "input-icon-start": "awsui_input-icon-start_2rhyz_32ma4_225",
  "input-icon-end": "awsui_input-icon-end_2rhyz_32ma4_232",
  "input-button-right": "awsui_input-button-right_2rhyz_32ma4_238",
  "inline-label-trigger-wrapper": "awsui_inline-label-trigger-wrapper_2rhyz_32ma4_242",
  "inline-label-trigger-wrapper-full-width": "awsui_inline-label-trigger-wrapper-full-width_2rhyz_32ma4_245",
  "inline-label-wrapper": "awsui_inline-label-wrapper_2rhyz_32ma4_249",
  "inline-label-wrapper-full-width": "awsui_inline-label-wrapper-full-width_2rhyz_32ma4_252",
  "inline-label": "awsui_inline-label_2rhyz_32ma4_242",
  "inline-label-disabled": "awsui_inline-label-disabled_2rhyz_32ma4_277",
  "input-adorned-container-disabled": "awsui_input-adorned-container-disabled_2rhyz_32ma4_302",
  "input-adorned-container-invalid": "awsui_input-adorned-container-invalid_2rhyz_32ma4_310",
  "input-adorned-container-warning": "awsui_input-adorned-container-warning_2rhyz_32ma4_323",
  "input-prefix": "awsui_input-prefix_2rhyz_32ma4_337",
  "input-suffix": "awsui_input-suffix_2rhyz_32ma4_338",
  "input-adornment-content": "awsui_input-adornment-content_2rhyz_32ma4_351",
  "input-adornment-divider": "awsui_input-adornment-divider_2rhyz_32ma4_360",
  "input-adorned": "awsui_input-adorned_2rhyz_32ma4_9"
};
  